import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="m-3">
                <b>404</b> Not Found
            </div>
        )
    }
}

export default NotFound;